export function convertirFormatoFecha(fecha) {
    // Dividir la fecha en año, mes y día
    var partesFecha = fecha.split('-');

    // Crear un objeto de fecha con los componentes
    var fechaObjeto = new Date(partesFecha[0], partesFecha[1] - 1, partesFecha[2]);

    // Obtener día, mes y año del objeto de fecha
    var dia = fechaObjeto.getDate();
    var mes = fechaObjeto.getMonth() + 1;
    var año = fechaObjeto.getFullYear();

    // Formatear la fecha en el formato deseado
    var fechaFormateada = dia.toString().padStart(2, '0') + '/' + mes.toString().padStart(2, '0') + '/' + año;

    return fechaFormateada;
}

export function revertirFormatoFecha(fecha) {
    // Dividir la fecha en año, mes y día
    var partesFecha = fecha.split('/');
    // Crear un objeto de fecha con los componentes
    var fechaObjeto = new Date(partesFecha[2], partesFecha[1] - 1, partesFecha[0]);

    // Obtener día, mes y año del objeto de fecha
    var dia = fechaObjeto.getDate();
    var mes = fechaObjeto.getMonth() + 1;
    var año = fechaObjeto.getFullYear();

    // Formatear la fecha en el formato deseado
    var fechaFormateada = año + '-' + mes.toString().padStart(2, '0') + "-" + dia.toString().padStart(2, '0');

    return fechaFormateada;
}
export function formateoBasico(fecha) {
    var fechaOriginal = new Date(fecha);

    // Obtener día, mes y año
    var dia = fechaOriginal.getDate();
    var mes = fechaOriginal.getMonth() + 1; // Los meses en JavaScript se indexan desde 0
    var año = fechaOriginal.getFullYear();

    // Formatear la fecha en formato dd/mm/yyyy
    var fechaFormateada = año + '-' + (mes < 10 ? '0' : '') + mes + '-' + (dia < 10 ? '0' : '') + dia;
    return fechaFormateada;
}

export const formatearEmperesaApi = (idEmpresa) => {
    const idEmpresavar = JSON.parse(idEmpresa)
    let ids = []
    idEmpresavar?.map((item) => {
        ids.push(item)
    })
    return JSON.stringify(ids)

}
export const formateoDateATiempo = (fecha) => {
    var fechaActual = fecha;

    // Obtener las horas, minutos y segundos de la fecha actual
    var hora = fechaActual.getHours();
    var minutos = fechaActual.getMinutes();
    var segundos = fechaActual.getSeconds();

    // Formatear la hora en formato HH:MM:SS
    var horaFormateada = (hora < 10 ? '0' : '') + hora + ':' +
        (minutos < 10 ? '0' : '') + minutos + ':' +
        (segundos < 10 ? '0' : '') + segundos;

    return horaFormateada
}

// formato 2024-07-17T06:49:28.000Z
export function extraerHora(fechaHoraISO) {
    // Crear un objeto Date a partir de la cadena ISO
    const fechaHora = new Date(fechaHoraISO);

    // Obtener la hora, minutos y segundos
    const horas = fechaHora.getUTCHours();
    const minutos = fechaHora.getUTCMinutes();
    const segundos = fechaHora.getUTCSeconds();

    // Formatear la hora como HH:MM:SS
    const horaFormateada = `${String(horas).padStart(2, '0')}:${String(minutos).padStart(2, '0')}:${String(segundos).padStart(2, '0')}`;

    return horaFormateada;
}

export function isoAUtc(isoDate) {
    // Crear un objeto Date a partir de la fecha en formato ISO
    const date = new Date(isoDate);


    // Extraer las partes de la fecha en UTC
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Los meses empiezan en 0
    const day = String(date.getUTCDate()).padStart(2, '0');

    // Construir la fecha en formato UTC
    return `${year}-${month}-${day}`;
}
export const invertirFormatoFecha = (fecha) => {
    // Separar la fecha en año, mes y día
    const [year, month, day] = fecha.split('-');

    // Devolver la fecha en formato dd-MM-yyyy
    return `${day}-${month}-${year}`;
}

export const extraerHoraDate = (fechaFormatoDate) => {
    if(fechaFormatoDate)
    {

        const fecha = fechaFormatoDate
        const horas = fecha.getHours().toString().padStart(2, '0');
        const minutos = fecha.getMinutes().toString().padStart(2, '0');
        const segundos = fecha.getSeconds().toString().padStart(2, '0');
    
        return `${horas}:${minutos}:${segundos}`;
    }
    else{
        return null;
    }
}
// parametro en formato yyyy-mm-dd
export const ultimoDiaDelMes = (dateString) => {
    const [year, month] = dateString.split('-').map(Number); // Extrae año y mes de la fecha
    const lastDay = new Date(year, month, 0).getDate(); // Obtiene el último día del mes
    return `${year}-${String(month).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`; // Formatea la fecha
};

export function obtenerHoraAmPm(fecha) {
    // Obtener horas y minutos
    let horas = fecha.getHours();
    let minutos = fecha.getMinutes();
  
    // Determinar AM o PM
    let ampm = horas >= 12 ? 'PM' : 'AM';
  
    // Convertir las horas al formato de 12 horas
    horas = horas % 12;
    horas = horas ? horas : 12; // El 0 debe ser 12 en formato de 12 horas
  
    // Asegurar que los minutos tengan dos dígitos
    minutos = minutos < 10 ? '0' + minutos : minutos;
  
    // Retornar el formato de hora
    return `${horas}:${minutos} ${ampm}`;
  }

//   para horas hh:mm:ss
  export function convertirHoraAmPm(hora24) {
    // Separar la hora, minutos y segundos
    let [horas, minutos] = hora24.split(':');
    
    // Convertir las horas y minutos a números
    horas = parseInt(horas, 10);
    minutos = parseInt(minutos, 10);

    // Determinar AM o PM
    let ampm = horas >= 12 ? 'PM' : 'AM';

    // Convertir las horas al formato de 12 horas
    horas = horas % 12;
    horas = horas ? horas : 12; // El 0 debe ser 12 en formato de 12 horas

    // Asegurar que los minutos tengan dos dígitos
    minutos = minutos < 10 ? '0' + minutos : minutos;

    // Retornar el formato de hora
    return `${horas}:${minutos}${ampm}`;
}

export function convertirUTCaISO(utcString) {
    // Crear un objeto Date a partir de la cadena UTC
    const date = new Date(`${utcString} UTC`);
    
    // Convertir a formato ISO 8601
    return date.toISOString();
  }


  export function convertirIsoZComoLocal(fechaIsoUtc) {
  if (typeof fechaIsoUtc !== 'string' || !fechaIsoUtc.endsWith('Z')) {
    throw new Error('La cadena debe tener formato ISO con "Z".');
  }

  // Quitar la Z y crear el Date como local
  const fechaSinZ = fechaIsoUtc.replace(/Z$/, '');
  const fechaLocal = new Date(fechaSinZ);

  if (isNaN(fechaLocal)) {
    throw new Error('Fecha inválida.');
  }

  return fechaLocal;
}